<template>
  <div class="nextButton" @click="$emit('clicked')">
    <span class="nextButton__label">{{ label }}</span>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.98293 19.3882C8.64211 19.0568 8.64211 18.5196 8.98293 18.1883L15.3476 12.0004L8.98293 5.81244C8.64211 5.48109 8.64211 4.94386 8.98293 4.61251C9.32375 4.28115 9.87633 4.28115 10.2172 4.61251L17.199 11.4004C17.5398 11.7317 17.5398 12.269 17.199 12.6003L10.2172 19.3882C9.87633 19.7196 9.32375 19.7196 8.98293 19.3882Z" fill="#656D78"/>
    </svg>
  </div>
</template>


<script>

export default {
  name: 'nextButton-form',
  data() {
    return {
    }
  },
  props: {
    label: {
      type:String,
      default:''
    },
  }
}</script>

<style lang="scss" scoped>
@import "../../../../sass/commons/commonVariables.scss";

.nextButton{
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  align-items: center;

  &__label{
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/NextButton.vue